export default "__VITE_ASSET__xzzNFz$V__"